import styled from "styled-components";

const StyledUserMsg = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-bottom: .5rem;

    img{
        display: inline-block;
        width: 2rem;
        height: 2rem;
        border-radius: 50%;
    }
    .msgContainer{
        background-color: ${({ theme }) => theme.colors.primary};
        padding: .35rem .5rem;
        border-radius: 0 .5rem .5rem;
        margin-left: 0.75rem;
        color: ${({ theme }) => theme.colors.background.elements};
        position: relative;
        font-size: 14px;

        &::before{
            content: "";
            position: absolute;
            left: -0.625rem;
            border-right: 0.625rem solid ${({ theme }) => theme.colors.primary};
            border-bottom: 0.625rem solid transparent;
            border-top: 0rem solid;
            top: 0;
        }

        span{
            
            opacity: .5;
            font-size: 12px;
            direction: ltr;
            display: block;
        }
    }
`
function UserMsg({ msg }) {


    return (
        <StyledUserMsg>
            <div className="msgContainer">
                <p className="mb-0">{msg.msg}</p>
                <span>{msg.time}</span>
            </div>
            <img src={msg.userImg} alt="Profile" />
        </StyledUserMsg>
    );
}

export default UserMsg;